import React from "react";
import Logo from "@/components/ui/logo";
import LogoImage from "@/../public/images/icons/Logo.png";
import DesktopHeaderNav from "@/components/navigation/desktopHeaderNav";
import LanguageSelectWrapper from "@/components/languageSelectWrapper";
import { Container, Spinner } from "react-bootstrap";
import { BASE_URL } from "@/constants";

interface DesktopHeaderProps {
  onOpenSelected: () => void;
  branchLogo?: string | null;
  isLoading?: boolean;
}

const DesktopHeader: React.FC<DesktopHeaderProps> = ({
  onOpenSelected,
  branchLogo,
  isLoading = false,
}) => {
  const logoSrc = branchLogo ? `${BASE_URL}/${branchLogo}` : LogoImage;
  return (
    <header className="d-none d-md-block position-fixed top-0 start-0 end-0 bg-white shadow-down z-1">
      <Container>
        <div
          className="d-flex align-items-center"
          style={{ height: "var(--app-header-height-desktop)" }}
        >
          {isLoading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Logo
              src={logoSrc}
              classNameImg={branchLogo ? "rounded-circle" : ""}
              height={branchLogo ? 45 : undefined}
            />
          )}
          <div className="ms-auto d-flex align-items-center gap-6">
            <DesktopHeaderNav onOpenSelected={onOpenSelected} />
            <LanguageSelectWrapper view="desktop" />
          </div>
        </div>
      </Container>
    </header>
  );
};

export default DesktopHeader;
